import authRules from '../authRules.js';

const addAssignmentEditDescription = (user) => {
  const { assignmentComment } = user.securityLevels;
  if (assignmentComment >= authRules.addAssignmentEditDescription.assignmentComment) {
    return true;
  } else {
    return false;
  }
}

export default addAssignmentEditDescription;
